import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ToastrModule } from "ngx-toastr";

import { SidebarModule } from './layouts/sidebar/sidebar.module';
import { NavbarModule} from './layouts/navbar/navbar.module';
import { FooterModule } from './shared/footer/footer.module';
import { FixedPluginModule} from './shared/fixedplugin/fixedplugin.module';

import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { ConfirmComponent } from './shared/modals/confirm/confirm.component';
import { InformationComponent } from './shared/modals/information/information.component';
import { TimedComponent } from './shared/modals/timed/timed.component';
import { CbmInfoComponent } from './shared/modals/cbm-info/cbm-info.component';

import { UpdateStatusComponent } from './shared/modals/update-status/update-status.component';

import { TechRatingComponent } from "./shared/modals/cbm-tech-rating/tech-rating.component";

//import { ChangePasswordComponent } from "./core/change-pass/change-pass.component";

import { BlockNewLoginComponent } from "./core/block-login/block-new-login.component";
import { LoginComponent } from '@core/login/login.component';
import { SharedModule } from '@shared/shared.module';

import { AuthGuard } from '@shared/services/guards/auth-guard.service';
import { RoleGuard } from '@app/shared/services/guards/role-guard.service';
import { CanDeactivateGuard } from '@app/shared/services/guards/deactivate-guard.service';
import { AuthInterceptor } from '@shared/services/http/auth.inteceptor';

@NgModule({ declarations: [
        AppComponent,
        BlockNewLoginComponent,
        AdminLayoutComponent,
        ConfirmComponent,
        InformationComponent,
        TimedComponent,
        CbmInfoComponent,
        LoginComponent,
        UpdateStatusComponent,
        TechRatingComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
        RouterModule.forRoot(AppRoutes, { onSameUrlNavigation: 'reload' }),
        SidebarModule,
        NavbarModule,
        ToastrModule.forRoot(),
        FooterModule,
        FixedPluginModule,
        SharedModule], providers: [
        AuthGuard,
        RoleGuard,
        CanDeactivateGuard,
        provideZoneChangeDetection(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
